import { motion } from "framer-motion";
import { noTranslateProps } from "@/utils/pageTranslation";

const KeyboardGuide = ({ showKeyboardGuide, handleCloseKeyboardGuide }) => {
  if (!showKeyboardGuide) return null;
  return (
    <div className="w-[350px] absolute bottom-16 z-50">
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        exit={{ opacity: 0, y: 10 }}
        className="w-full p-4 flex flex-col gap-4 items-center relative bg-[#F7F6FF] rounded-lg shadow-lg"
      >
        <p className="text-lg font-bold text-center text-black">
          Hold{" "}
          <kbd
            {...noTranslateProps(
              "px-2 py-0.5 rounded border border-black/40 bg-white font-mono text-base",
            )}
          >
            S
          </kbd>{" "}
          to talk with the AI tutor
        </p>
        <p className="text-sm text-center text-black/70">
          Hold the <span className="font-semibold">Space bar</span> to write on
          the pad — or tap it to stay in draw mode. Tap{" "}
          <kbd
            {...noTranslateProps(
              "px-1.5 py-0.5 rounded border border-black/30 bg-white font-mono",
            )}
          >
            S
          </kbd>{" "}
          or{" "}
          <kbd
            {...noTranslateProps(
              "px-1.5 py-0.5 rounded border border-black/30 bg-white font-mono",
            )}
          >
            Enter
          </kbd>{" "}
          to submit your work.
        </p>
        <button
          className="absolute -top-4 right-4 border border-black rounded-full px-2 py-1 text-sm"
          onClick={handleCloseKeyboardGuide}
        >
          X
        </button>
      </motion.div>
    </div>
  );
};

export default KeyboardGuide;
